import styled from "styled-components";

export const Container = styled.div`
  display: flex;

  width: 100%;
  height: 100%;

  background-color: #f5f5f5;

  font-family: "Mulish";

  padding: 1rem;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;

  overflow: auto;

  .header {
    display: flex;

    width: 100%;
    height: 20%;

    align-items: flex-start;
    justify-content: space-between;

    gap: 0.5rem;

    .header-text {
      font-size: 1.2rem;
      font-weight: bold;
    }

    #func {
      color: #252733;
    }

    #name {
      color: #2d7bbc;
    }
  }

  .user-info {
    display: flex;
    align-items: flex-start;

    gap: 2rem;

    align-items: center;

    div {
      display: flex;

      gap: 0.5rem;
    }

    .Search-container {
      display: flex;

      width: 25rem;
      height: 3rem;

      align-items: center;

      background-color: white;

      border-radius: 2rem;

      padding: 1rem;
    }

    #searchBox {
      width: 100%;
      height: 100%;

      border: none;

      margin-left: 0.2rem;

      background: none;
    }
  }

  .header-manager {
    display: flex;

    align-items: flex-start;

    padding-right: 2rem;

    gap: 2rem;
  }

  .process-manager {
    display: flex;
    flex-direction: column;

    gap: 1rem;

    margin-left: 1.5rem;
  }

  #keep-title {
    font-size: 1.2rem;
    font-weight: 600;

    color: #2d7bbc;
  }

  .table-wrapper {
    display: flex;
    flex-direction: column;

    width: 100%;
    height: 70vh;

    padding: 0.5rem 1rem;

    overflow: auto;

    background-color: white;

    border-radius: 0.25rem;
  }

  tr,
  a {
    display: flex;

    width: 100%;
    min-height: 3.5rem;

    font-size: 0.9rem;

    border-bottom: #dfe0eb 1px solid;
    border-radius: 0rem;

    white-space: nowrap;

    color: black;

    text-decoration: none;

    align-items: center;
    justify-content: center;
  }

  th {
    display: flex;

    position: relative;

    width: 12.5%;
    height: 2rem;

    align-items: center;
    justify-content: center;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    font-size: 1rem;

    color: #2d7bbc;
  }

  .process-comp {
    display: flex;

    width: 100%;
    min-height: 3.5rem;

    font-size: 0.9rem;

    border-bottom: #dfe0eb 1px solid;
    border-radius: 0rem;

    white-space: nowrap;

    color: black;

    text-decoration: none;

    align-items: center;
    justify-content: center;

    a {
      transition: all 0.1s;

      :last-child {
        border-bottom: none;
      }
    }

    a:hover {
      cursor: pointer;

      background-color: #3751ff;

      color: white;
    }

    td {
      display: flex;

      position: relative;

      width: 12.5%;
      height: 2rem;

      align-items: center;
      justify-content: center;

      font-size: 1rem;

      button {
        width: 5rem;
        height: 2rem;

        border-radius: 0.25rem;

        cursor: pointer;

        font-weight: 600;
      }

      p {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        font-weight: bold;
      }
    }

    #prop-name {
      justify-content: flex-start;

      text-transform: capitalize;
    }

    .get-in-form {
      border: none;

      color: white;
      background-color: #2d7bbc;
    }

    .disabled-get-in-form {
      border: none;
      color: #2d7bbc;
      opacity: 0.5;
      pointer-events: none;

      transition: 0.4s;

      :hover {
        border-color: red;

        color: red;
      }
    }

    #process-text {
      color: #8a8a8a;
      font-weight: 600;
      text-transform: uppercase;
    }
  }
`;
